import AppCommandBar from 'app/AppCommandBar'
import { AutoStack, FlexSpinner } from 'components'
import { ViewAuthorizer } from 'components/AccessDenied'
import { StickyPane } from 'components/StickyPane'
import { CheckBoxContainer, Status } from 'components/TimeLine'
import { useAuthContext } from 'hooks/useAuthContext'
import { useCommand } from 'hooks/useCommand'
import { useUserSuggestions } from 'hooks/useUserSuggestions'
import _ from 'lodash'
import { User, UserRole } from 'model'
import {
  Checkbox,
  IPersonaProps,
  Label,
  NormalPeoplePicker,
} from 'office-ui-fabric-react'
import React from 'react'
import 'react-calendar-timeline/lib/Timeline.css'
import { useTranslation } from 'react-i18next'
import { Page, Section } from 'views/ProvingDetailsView/Layout'
import {
  FilterObject,
  GenerateHierarchy,
  GenerateResources,
  StatusItem,
} from './AppletViewExtensions'
import { BookingsAppletTimeLine } from './BookingsAppletTimeLine'
import { useReadProvingsForAppletQuery } from './BookingsView.generated'
import { MinWidthContainer, ResourceContainer } from './Styles'

// omport Timeline from 'react-calendar-timeline'

const categoriesTobeRemoved = [
  'provingGround',
  'lodging',
  'office',
  'workshop',
  'building',
  'ferryConnection',
  'accessory',
]

export const additionalTypes = [
  'remoteControl',
  'interimBadge',
  'radio',
  'accessCard',
]

export const BookingsAppletView: React.FC = () => {
  const { t } = useTranslation()
  const { suggestUsers } = useUserSuggestions()
  const [provingGround, setProvingGround] = React.useState(
    '5dcc1c9362079125e6f2e000'
  )
  const { loading, data, refetch, error } = useReadProvingsForAppletQuery({
    variables: {
      status: [8, 9, 10],
      id: provingGround,
    },
  })

  const [viewProps] = React.useState<boolean>(true)

  const auth = useAuthContext()
  const isServiceTeam = auth.hasUserRole(UserRole.ServiceTeam)

  const [filter, setFilter] = React.useState<FilterObject>({
    hidden: true,
    groupByDepartment: false,
    resources: [] as string[],
    resourceCategories: ['office', 'building', 'workshop'] as string[],
    persons: [] as User[],
    vehicles: [] as string[],
  } as FilterObject)

  useCommand(
    {
      key: 'update',
      text: t('field.applet.commandBar.update'),
      iconProps: { iconName: 'AnalyticsReport' },
      onClick: () => {
        refetch({
          variables: {
            status: [8, 9, 10],
            id: provingGround,
          },
        } as any)
      },
    },
    [data]
  )
  // useCommand(
  //   {
  //     key: 'hide',
  //     text: viewProps
  //       ? t('field.applet.commandBar.show')
  //       : t('field.applet.commandBar.hide'),
  //     iconProps: { iconName: 'Hide' },
  //     onClick: () => {
  //       viewProps ? setviewProps(false) : setviewProps(true)
  //     },
  //   },
  //   [viewProps, setviewProps, data]
  // )

  // General View data and Filter options
  const serviceTeamProvingGrounds: any = []
  // tslint:disable-next-line: no-unused-expression
  data &&
    data.provingGrounds &&
    data.provingGrounds.forEach(
      (pg) =>
        pg.authorizedEditors &&
        pg.authorizedEditors.forEach((ae) => {
          if (ae._id === auth.user!._id) {
            serviceTeamProvingGrounds.push(pg)
          }
        })
    )

  const provingGrounds =
    data && data.provingGrounds
      ? _.orderBy(data.provingGrounds, ['title'], ['asc'])
      : []

  const sortedServiceTeamProvingGrounds = _.orderBy(
    serviceTeamProvingGrounds,
    ['title'],
    ['asc']
  )
  const categories =
    data &&
    _.remove(data.resourceCategories, (c: any) => {
      return categoriesTobeRemoved.includes(c._id)
    })
      ? data.resourceCategories
      : []

  const provings =
    data && data.provings
      ? data.provings.map((item: any) => {
          if (item.provingGround && item.provingGround._id === provingGround) {
            return item
          }
          return undefined
        })
      : []

  // Fetch and build resourceObject including Hierarchy Builder for Timeline View
  const resourceObject = GenerateResources(data)
  const hierarchy = GenerateHierarchy(resourceObject, filter, t)

  // Functions / Handlers and Filter Propertie modifiers
  const ExtendOrTrimArray = (array: string[], item: string): string[] => {
    const exist = _.findIndex(array, (i: string) => {
      return i === item
    })

    if (exist !== -1) {
      _.remove(array, (i: string) => {
        return i === item
      })
    } else {
      array.push(item)
    }
    return array.slice()
  }

  const CheckSelected = (id: string): boolean => {
    return provingGround && provingGround === id ? true : false
  }

  const CheckSelectedIn = (array: string[], item: string): boolean => {
    return (
      _.findIndex(array, (i: string) => {
        return i === item
      }) > -1
    )
  }

  const OnPeoplePickerChange = (items?: any | undefined): void => {
    setFilter({
      ...filter,
      persons: items ? items : ([] as IPersonaProps[]),
    })
  }

  return (
    <ViewAuthorizer
      roles={[
        UserRole.SystemAdministrator,
        UserRole.Reader,
        UserRole.ProvingOrganisation,
        UserRole.ResourceManager,
        UserRole.ServiceTeam,
      ]}
    >
      <StickyPane>
        <FlexSpinner loading={loading} error={error}>
          <Page>
            <AppCommandBar />
            {viewProps && (
              <>
                <Section label={t(`field.provingGround.label`)}>
                  <AutoStack horizontal={true} wrap={true}>
                    {!isServiceTeam &&
                      provingGrounds &&
                      provingGrounds.map((ground: any) => {
                        return (
                          <MinWidthContainer key={ground._id}>
                            <CheckBoxContainer>
                              <Checkbox
                                label={ground.title}
                                checked={CheckSelected(ground._id)}
                                onChange={() => {
                                  setProvingGround(ground._id)
                                  setFilter({
                                    ...filter,
                                    resources: [],
                                  })
                                }}
                              />
                            </CheckBoxContainer>
                          </MinWidthContainer>
                        )
                      })}
                    {isServiceTeam &&
                      sortedServiceTeamProvingGrounds &&
                      sortedServiceTeamProvingGrounds.map((ground: any) => {
                        return (
                          <MinWidthContainer key={ground._id}>
                            <CheckBoxContainer>
                              <Checkbox
                                label={ground.title}
                                checked={CheckSelected(ground._id)}
                                onChange={() => {
                                  setProvingGround(ground._id)
                                  setFilter({
                                    ...filter,
                                    resources: [],
                                  })
                                }}
                              />
                            </CheckBoxContainer>
                          </MinWidthContainer>
                        )
                      })}
                  </AutoStack>
                </Section>
                <Section label={t(`field.applet.resources.label`)}>
                  <AutoStack horizontal={true} wrap={true}>
                    {resourceObject.buildings &&
                      resourceObject.buildings.length > 0 && (
                        <AutoStack>
                          <MinWidthContainer>
                            <Label>
                              {t(`field.applet.resources.buildings`)}
                            </Label>
                          </MinWidthContainer>
                          <ResourceContainer>
                            {resourceObject.buildings.map((building: any) => {
                              return (
                                <MinWidthContainer key={building._id}>
                                  <CheckBoxContainer>
                                    <Checkbox
                                      label={`${building.title}`}
                                      checked={CheckSelectedIn(
                                        filter.resources,
                                        building._id
                                      )}
                                      onChange={() => {
                                        setFilter({
                                          ...filter,
                                          resources: ExtendOrTrimArray(
                                            filter.resources,
                                            building._id
                                          ),
                                        })
                                      }}
                                    />
                                  </CheckBoxContainer>
                                </MinWidthContainer>
                              )
                            })}
                          </ResourceContainer>
                        </AutoStack>
                      )}
                    {resourceObject.garages &&
                      resourceObject.garages.length > 0 && (
                        <AutoStack>
                          <MinWidthContainer>
                            <Label>{t(`field.applet.resources.garages`)}</Label>
                          </MinWidthContainer>
                          <ResourceContainer>
                            {resourceObject.garages.map((garage: any) => {
                              return (
                                <MinWidthContainer key={garage._id}>
                                  <CheckBoxContainer>
                                    <Checkbox
                                      label={`${garage.title}`}
                                      checked={CheckSelectedIn(
                                        filter.resources,
                                        garage._id
                                      )}
                                      onChange={() => {
                                        setFilter({
                                          ...filter,
                                          resources: ExtendOrTrimArray(
                                            filter.resources,
                                            garage._id
                                          ),
                                        })
                                      }}
                                    />
                                  </CheckBoxContainer>
                                </MinWidthContainer>
                              )
                            })}
                          </ResourceContainer>
                        </AutoStack>
                      )}
                  </AutoStack>
                </Section>
                <Section label={t(`field.applet.additionalResources.label`)}>
                  <AutoStack horizontal={true} wrap={true}>
                    {categories &&
                      categories.map((category: any) => {
                        return (
                          <MinWidthContainer key={category._id}>
                            <CheckBoxContainer>
                              <Checkbox
                                label={t(`field.category.${category._id}`)}
                                checked={CheckSelectedIn(
                                  filter.resourceCategories,
                                  category._id
                                )}
                                onChange={() => {
                                  setFilter({
                                    ...filter,
                                    resourceCategories: ExtendOrTrimArray(
                                      filter.resourceCategories,
                                      category._id
                                    ),
                                  })
                                }}
                              />
                            </CheckBoxContainer>
                          </MinWidthContainer>
                        )
                      })}
                    {additionalTypes &&
                      additionalTypes.map((type: any) => {
                        return (
                          <MinWidthContainer key={type}>
                            <CheckBoxContainer>
                              <Checkbox
                                label={t(`field.type.${type}`)}
                                checked={CheckSelectedIn(
                                  filter.resourceCategories,
                                  type
                                )}
                                onChange={() => {
                                  setFilter({
                                    ...filter,
                                    resourceCategories: ExtendOrTrimArray(
                                      filter.resourceCategories,
                                      type
                                    ),
                                  })
                                }}
                              />
                            </CheckBoxContainer>
                          </MinWidthContainer>
                        )
                      })}
                  </AutoStack>
                </Section>
                <Section label={t(`field.applet.persons.label`)}>
                  <NormalPeoplePicker
                    onChange={OnPeoplePickerChange}
                    defaultSelectedItems={filter.persons}
                    onResolveSuggestions={suggestUsers as any}
                    itemLimit={50}
                  />
                </Section>
              </>
            )}
            <Section label={t(`enum.status.label`)}>
              <AutoStack horizontal={true} wrap={true}>
                {Status.map((status: any) => {
                  return (
                    <StatusItem
                      key={status.id}
                      title={t(`enum.status.${status.id}`)}
                      color={status.color}
                    />
                  )
                })}
              </AutoStack>
            </Section>
            <BookingsAppletTimeLine
              groupHierarchy={hierarchy}
              provings={provings || []}
              filter={
                {
                  groupByDepartment: filter.groupByDepartment,
                  resources: filter.resources,
                  resourceCategories: filter.resourceCategories,
                  persons: filter.persons,
                  vehicles: filter.vehicles,
                } as FilterObject
              }
            />
          </Page>
        </FlexSpinner>
      </StickyPane>
    </ViewAuthorizer>
  )
}
